var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-pannellum",on:{"mouseup":_vm.onMouseUp,"touchmove":_vm.onTouchMove,"touchend":_vm.onTouchEnd}},[_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.info))]),_c('div',{staticClass:"default-slot"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }